export default "__VITE_ASSET__6d0a7aa3__$_?component__"